import { render } from "./_user.vue?vue&type=template&id=1c532ca2&lang=pug"
import script from "./_user.vue?vue&type=script&lang=js"
export * from "./_user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__